<template>
  <div v-if="item" class="border">
    <div v-if="!changeItem">
      <fields-list :simple="true" :item="item" :fields="fields" />
      <button class="btn btn-info mw" @click="updateItem">
        {{ button_key | setText() }}
      </button>
    </div>
    <div v-else>
      <fields-list
        @change="updateItem"
        :simple="true"
        :item="item"
        :fields="fields"
      />
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  data: () => ({
    cardLink: "clients",
    cardSetLink: "clients",
    item: null,
    fields: [],
  }),
  props: {
    fieldList: {
      default: function () {
        return [];
      },
    },
    id: {
      default: null,
    },
    changeItem: {
      default: true,
    },
    button_key: {
      default: "apply",
    },
  },
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
    this.fields = this.fieldList;
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      if (item && item.id) {
        this.$loading(true);
        this.$emit("input", item);
      }
    },
  },
};
</script>
